import React from 'react'

/**
 * Notification
 */
export const NOTIFY_RESERVE = 'NOTIFY_RESERVE'
export const NOTIFY_CREDIT_BID = 'NOTIFY_CREDIT_BID'
export const NOTIFY_DEFAULT_TEXT = 'Notify Me'
export const NOTIFY_SUBMITTED_TEXT = "You'll be notified"
export const ARV_TOOLTIP_CONTENT = (
  <div>
    <p>
      This is an automated estimate of the property’s potential market value.
      The value is provided by a third party based on current market valuations
      and assumed average condition.
    </p>
    <p>
      This is only a guideline. We recommend you do your own research on
      comparable sales and any costs associated with improving the property.
    </p>
  </div>
)
export const EST_DEBT_TOOLTIP_CONTENT =
  'Estimate of the amount owed by the homeowner'

/**
 * Bid Actions
 */
export const MAKE_YOUR_OFFER = 'Make Your Offer'
export const REGISTER_TO_BID = 'Register to Bid'
export const REGISTERED_FOR_AUCTION = "You're Registered!"
export const BID_PENDING = 'Placing your bid now...'
export const SAVE_PROPERTY_CTA = 'Save This Property'
export const SAVE_PROPERTY_CTA_TPS = 'Save for Updates'
export const VIEW_SIMILAR_PROPERTIES = 'View Similar Properties'

/**
 * Bid History
 */
export const NO_BIDDING_HISTORY = 'No Bidding History Available'

/**
 * PDP Banners
 */
export const MESSAGE_BID_REGISTER_SUCCESS =
  'Thank you for registering, you can now place a bid.'
export const MESSAGE_BID_REGISTER_SUCCESS_UNCONFIRMED =
  'Thank you for registering. Check your email to confirm your account in order to place a bid.'
export const MESSAGE_RE_SEND_CONFIRMATION_EMAIL = 'Re-send Confirmation Email'
export const MESSAGE_CHECK_YOUR_EMAIL_THEN_BID =
  'Check your email to confirm your account, then place a bid.'
export const MESSAGE_CHECK_YOUR_EMAIL_THEN_OFFER =
  'Check your email to confirm your account, then place an offer.'
export const TRANSIENT_MESSAGE_EMAIL_WAS_SENT =
  'A confirmation email has been sent'
export const TRANSIENT_MESSAGE_EMAIL_FAILED_TITLE =
  'Unable to send confirmation email'
export const TRANSIENT_MESSAGE_EMAIL_FAILED_BODY =
  'Please try again later or contact support.'
export const TRANSIENT_MESSAGE_PROPERTY_SAVED_TITLE = 'Save Successful'
export const TRANSIENT_MESSAGE_PROPERTY_SAVED_BODY =
  "You'll now receive updates on this property. View all your saved properties on your dashboard."
export const TRANSIENT_MESSAGE_NOTIFY_RESERVE_BODY =
  'The property has been saved. We will notify you when the Est. Credit Bid is disclosed.'
export const TRANSIENT_MESSAGE_NOTIFY_CREDIT_BID_BODY =
  'This property has been saved. We will notify you if the Credit Bid is updated or disclosed.'
export const TRANSIENT_MESSAGE_PROPERTY_UNSAVED_TITLE = 'Property Removed'
export const TRANSIENT_MESSAGE_PROPERTY_UNSAVED_BODY =
  'The property is no longer saved on the User Dashboard.'
export const TRANSIENT_MESSAGE_BID_AGAIN =
  'You did not meet the reserve. Bid again.'
export const TRANSIENT_MESSAGE_TPS_ONLINE_BID_AGAIN =
  'The Estimated Credit Bid has not been exceeded. Bid again.'
export const TRANSIENT_MESSAGE_CONTACT_AGENT_TITLE = 'Request Sent'
export const TRANSIENT_MESSAGE_CONTACT_AGENT_BODY =
  'Your message has been sent to the agent'

/**
 * Contact agent messages
 */
export const CONTACT_AGENT_FAILED_TITLE = 'Unable to send information'
export const CONTACT_AGENT_FAILED_BODY =
  'Please try again later or contact support.'
export const NOT_AVAILABLE = 'Not Available'

/**
 * Error Messages
 */
export const DISCONNECT_ERROR_MESSAGE =
  'Unable to update auction. Will try again in a few seconds.'
export const DOCUMENT_NOT_FOUND = "Looks like we don't have this document yet."
export const PIR_NOT_FOUND_TITLE = 'Sorry!'
export const PIR_NOT_FOUND_MESSAGE =
  "Something went wrong on our end. That file isn't available at the moment."

/**
 * After Auction
 */
// Used as an enum for showing bidding status labels or CTAs in sticky header
export const UNDER_CONTRACT = 'Under Contract'
export const COMING_SOON = 'Coming Soon'
export const FOR_SALE = 'For Sale'
export const PENDING = 'Pending'
export const SOLD = 'Sold'
export const SOLD_LABEL = 'Completed - Sold to 3rd Party'
export const ACTIVE = 'Active'
export const PENDING_SALE_RESULT = 'Pending Sale Result'
export const PENDING_SOLD = 'This property is in contracting'
export const SALE_PENDING = 'Sale Pending'
export const PLACE_BID = 'Place your Bid'
export const POSTPONED = 'Postponed - Awaiting new auction date'
export const POSTPONED_TO = 'Postponed to'

/**
 * Due Diligence Section
 */
export const DUE_DILIGENCE_CONTENT_MAP = {
  DUE_DILIGENCE_STEP_TWO_BODY_REO:
    'Preliminary reports are provided for reference.  Seek a professional for a full evaluation.',
  DUE_DILIGENCE_STEP_THREE_SUBTITLE_REO: 'Review Purchase Agreement',
  DUE_DILIGENCE_STEP_THREE_BODY_REO:
    "Details of the Seller's terms and conditions, and your rights as the buyer.",
  DUE_DILIGENCE_STEP_FOUR_SUBTITLE_REO: 'Prepare Your Finances',

  DUE_DILIGENCE_SUBTITLE: 'Take these steps to bid with confidence',
  DUE_DILIGENCE_BODY: (
    <span>
      Educate yourself before you bid.
      <br />
      <a
        href='/lp/learn-more/foreclosure/before-auction#due-diligence'
        target='_blank'
        rel='noreferrer'
      >
        Learn how to perform due diligence.
      </a>
    </span>
  ),
  DUE_DILIGENCE_STEP_ONE_BODY:
    'Check out third party reports on property condition, market value and neighborhood info.',
  DUE_DILIGENCE_STEP_TWO_BODY_TPS:
    'Reference the title document for information only. Check the property title and any possible liens on the property. Get a professional opinion for a full evaluation.',
  DUE_DILIGENCE_STEP_THREE_SUBTITLE_TPS: 'View Sales Documents',
  DUE_DILIGENCE_STEP_THREE_BODY_TPS:
    "Review sample documents for details of Seller's terms and conditions and your rights as the buyer.",
  DUE_DILIGENCE_STEP_FOUR_SUBTITLE_TPS: 'Prepare for Auction',
}

/**
 * ERV Lower Reserve/Credit Bid CTA
 */
export const ERV_LOWER_RESERVE = "Why's ERV lower than Reserve?"
export const ERV_LOWER_CREDIT_BID = "Why's ERV lower than Est. Credit bid?"

/**
 * Ids for query selector
 */
export const AUCTION_DETAILS_CTA_ID = 'auction_details_template_cta'

/**
 * Date Formatters
 */
export const SERVER_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ssZZ'
export const DAY_OF_MONTH_FORMAT = 'dddd, MMM DD, YYYY'

/**
 * CompSales
 */
export const RENTAL_ESTIMATE_DESCRIPTION =
  'Get information on monthly, median, low and high rental prices in the area.'
export const SIMILAR_PROPERTY_SOURCE = 'SIMILAR_PROPERTY_SOURCE'

/**
 * URL Actions
 */
export const REGISTER_REDIRECT_URL_ACTION = 'registration'
export const REDIRECT_ACTION_KEY = 'redirectIntent'

/**
 * Learn More URLs
 */
export const ONLINE_BID_DEPOSIT_LEARN_MORE_URL =
  'https://www.auction.com/lp/bid-deposit'
export const ILLINOIS_ONLINE_BID_DEPOSIT_LEARN_MORE_URL =
  'https://www.auction.com/lp/bid-deposit/#illinois-foreclosures'
export const NON_ONLINE_BID_DEPOSIT_LEARN_MORE_URL =
  'https://www.auction.com/lp/learn-more/glossary/#b'
